import React from 'react'
import style from './style.module.scss'
import Card from '../DailyNews/Card'
import PropTypes from 'prop-types'
import { useRouter } from 'next/router'

const IPLEditorPick = ({ editorPickData, isMobile }) => {
  const router = useRouter()
  return (<>
    <div className={`container d-none d-md-flex ${style.highlight} px-0`}>
      <h4 className='mt-0'>Editor Pick’s </h4>
      <Card news={editorPickData?.aResults} />
    </div>
    <div className={`container d-flex d-lg-none mt-0 flex-column ${style.highlight}`}>
      <h4>Editor Pick’s </h4>
      {router.pathname === '/ipl-indian-premier-league-2025/mobile' ? <Card news={editorPickData?.aResults} isMobile /> : <Card news={editorPickData?.aResults} />}
      </div>
  </>
  )
}

IPLEditorPick.propTypes = {
  editorPickData: PropTypes.object,
  isMobile: PropTypes.bool
}

export default IPLEditorPick
